import { fromClass } from "fw-model";

export class CasOrganizationIntegrationMetaData {
    AtsOrganizationMappingId: string;
    AtsOrganizationTemplateVersion: number;
    CasOrganizationName: string;
    ProviderType: string;
}

export enum CasProjectionQuestionKeyMode {
    UniqueIdentifier = 0,
    LegacyText = 1,
    CompactText = 2
}

export class CasOrganizationIntegration {
    Id: string;
    CasEnvironment: string;
    CasApplicationFormId: number;
    CasAssociationOrgId: number;
    AtsOrganizationTemplateId: string;
    IncludeInProgressApplications: boolean;
    AutoProvisionPrograms: boolean;
    AutoProvisionProgramTemplateId: string;
    AutoProvisionProgramsCheckedAtUtc: Date;
    HonorShortFieldKeys: boolean;
    QuestionKeyMode: CasProjectionQuestionKeyMode;
    IncludeCasUrl: boolean;
    IncludeCasCustomForms: boolean;
    IncludeOrganizationForms: boolean;
    IncludeApplicationPDF: boolean;
    IncludeRecommendations: boolean;
    IncludeSupplementalDocuments: boolean;
    UseRemoteDocuments: boolean;
    Enabled: boolean;
    @fromClass MetaData: CasOrganizationIntegrationMetaData;
}

export class CasOrganizationIntegrationClientModel {
    Id: string;
    CasEnvironment: string;
    CasFormIdentifier: string;
    CasOrganizationName: string;
    AtsOrganizationName: string;
    AtsOrganizationTemplateName: string;
    AtsOrganizationTemplateVersion: string;
    ProviderType: string;

    AtsOrganizationId: string;
    AtsSeasonId: string;
    AtsOrganizationMappingId: string;
    AtsOrganizationTemplateId: string;
    CasApplicationFormId: number;
    CasAssociationOrgId: number;

    AutoProvisionPrograms: boolean;
    AutoProvisionProgramTemplateId: string;
    AutoProvisionProgramsCheckedAtUtc: Date;
    Enabled: boolean;
}

export class CasOrgIntegrationOptions {
    IncludeInProgressApplications: boolean = false;
    HonorShortFieldKeys: boolean = false;
    IncludeCasUrl: boolean = false;
    IncludeCasCustomForms: boolean = false;
    IncludeOrganizationForms: boolean = true;
    IncludeApplicationPDF: boolean = true;
    IncludeRecommendations: boolean = true;
    IncludeSupplementalDocuments: boolean = true;
    UseRemoteDocuments: boolean = false;
    QuestionKeyMode: CasProjectionQuestionKeyMode = CasProjectionQuestionKeyMode.LegacyText;
}

export class CasProviderType {
    public Key: string = null;
    public Name: string = null;
}

export const CAS_PROVIDER_TYPE_OPTIONS: CasProviderType[] = [
    { Key: "full", Name: "Full" },
    { Key: "hybrid", Name: "Hybrid" },
    { Key: "aapi", Name: "AAPI" }
];
